import React, {useEffect, useState} from "react";

import {
    ATTR_ENUM_MAY_ADD, ATTR_ENUM_VALUES, ATTR_MAIN_PROJ_ID, ATTR_OBJ_ID,
    ATTR_TEXT, getValidAttr, replaceAll
} from "../prodect/ProsConnect";
import RadioButton from "../components/RadioButton";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import TextInput from "../components/TextInput";
import Spacer from "../components/Spacer";
import {prosAppNotifWarn} from "../prodect/ProsAppNotif";
import {setHelpContext} from "../prodect/HelpManager";
import TextButton from "../components/TextButton";

function onlyUnique(value, index, array) {
    return array.indexOf(value) === index
}

export default function EnumListEdit({title, closeCallback, setOptionsCallback, prevConfig, reservedIds, mainProjId}) {

    const isExistingEnumList = prevConfig && prevConfig[ATTR_OBJ_ID]
    const [enumId, setEnumId] = useState(isExistingEnumList ? prevConfig[ATTR_OBJ_ID] : "")
    const [description, setDescription] = useState(prevConfig ? getValidAttr(prevConfig, ATTR_TEXT, null) : "")
    const [mayAdd, setMayAdd] = useState(prevConfig ? prevConfig[ATTR_ENUM_MAY_ADD] : "none")
    const [initialEnums] =useState(prevConfig && prevConfig[ATTR_ENUM_VALUES] ? prevConfig[ATTR_ENUM_VALUES] : [])
    const [enumValues, setEnumValues] =useState(initialEnums)
    const [addingValue, setAddingValue] = useState([])
    const [editingNew, setEditingNew] = useState("")
    const [activeDragAndDrop, setActiveDragAndDrop] = useState(false)
    const [dragId, setDragId] = useState()

    const editorMayAdd = mayAdd === 'editor'
    const managerMayAdd = mayAdd === 'mgr'

    const removeEnumValue = (enumValue) => {
        setEnumValues(enumValues.filter(txt => txt !== enumValue))
    }

    useEffect(() => {
        setHelpContext('enumListSettings')
    }, [title])

    const parseNewEnums = (inTxt)=> {
        setEditingNew(inTxt)
        let filterAsList = replaceAll(inTxt, ",", ";")
        if(!filterAsList) return
        let enums = filterAsList.split(";")
            .map(txt => txt.trim())
            .filter(onlyUnique)
        setAddingValue(enums)
    }

    const addInputValues = ()=> {
        // remove empty ones and those that have already
        let newValues = addingValue
            .filter(txt => txt.length > 0)
            .filter(txt => !enumValues.find(current => current.toUpperCase() === txt.toUpperCase()))
        let newList = enumValues.concat(newValues)
        setEnumValues(newList)
        setEditingNew("")
        setAddingValue([])
        return newList
    }

    const handleDrag = (ev) =>  {
        setDragId(ev.currentTarget.id)
    }

    const handleDrop = (ev) => {
        const dropId = ev.currentTarget.id
        const newList = enumValues.filter(txt => txt !== dragId)
        const dropIndex = newList.findIndex(txt => txt === dropId) + 1
        if (dropIndex >= newList.length) {
            newList.push(dragId)
        } else {
            newList.splice(dropIndex, 0, dragId)
        }
        setEnumValues(newList)
    }

    const renderEnumValue =(enumValue)=> {
        return <div
            id={enumValue}
            key={`enum-${enumValue}`}
            className={"element-set valign-center width-100"}
            draggable={activeDragAndDrop}
            onDrop={handleDrop}
            onDragOver={(ev) => ev.preventDefault()}
            onDrag={handleDrag}
            >
                <BasicButton
                    icon={"drag-v"}
                    onMouseDown={()=>{
                        setActiveDragAndDrop(true)
                    }}
                />
                <span className={"flex-grow"}>
                    {enumValue}
                </span>
                <BasicButton
                    icon={"delete"}
                    action={() => removeEnumValue(enumValue)}
                />
        </div>
    }

    function isEnumTitleValid(){
        return enumId.length > 0
    }

    function renderEditInfo(){
        const numOfNew = enumValues.filter(txt => initialEnums.indexOf(txt) < 0).length
        const numOfRemoved = initialEnums.filter(txt => enumValues.indexOf(txt) < 0).length
        const noteNew = numOfNew ? <p className={"margin-0"}>Uusia: {numOfNew}</p> : null
        const noteRemove = numOfRemoved ? <p>Poistettavia: {numOfRemoved}</p> : null
        if(!noteNew && !noteRemove) return null
        return <div className={"msg msg-info margin-top"}>
            {noteNew}
            {noteRemove}
        </div>
    }

    function renderEnumList() {
        if (!isEnumTitleValid()) return null
        return <>
            <Spacer line/>
            {enumValues.map(it => renderEnumValue(it))}
            <Spacer/>
            <TextButton
                label={"Lisää arvo(t)"}
                icon={"plus"}
                placeholder={"Kirjoita uusi valinta"}
                value={editingNew}
                onChange={val => {
                    parseNewEnums(val)
                }}
                onSubmit={() => {
                    addInputValues()
                }}
                info={"Voit lisätä useita samalla kertaa laittamalla ; merkin lisättävien arvojen väliin"}
                // isControlled (these were here before changing TextInput to TextButton)
                // required
            />
            {renderEditInfo()}
        </>
    }

    function hasEditedEnumObject(newConfig){
        let compareConfig = prevConfig || {}
        if(!isExistingEnumList) {
            compareConfig[ATTR_OBJ_ID] = null
        }
        let changes = Object.keys(newConfig).filter((o, ) => {
            return newConfig[o] !== compareConfig[o]
        })
        return changes.length > 0 || JSON.stringify(enumValues) !== JSON.stringify(initialEnums)
    }

    function renderConfirmButton(){
        let newConfig = {
            [ATTR_OBJ_ID]: enumId,
            [ATTR_TEXT]: description,
            [ATTR_ENUM_MAY_ADD]: mayAdd,
        }
        if (mainProjId) {
            newConfig[ATTR_MAIN_PROJ_ID] = mainProjId
        }
        let isDisabled = !isEnumTitleValid()
            || !hasEditedEnumObject(newConfig)
            || enumValues.length < 1
        return <ConfirmButton
            label={title}
            disabled={isDisabled}
            action={()=> {
                if (!isExistingEnumList) {
                    //if (isDisabled) {
                    //    prosAppNotifWarn("Aseta listalle ID")
                    //    return
                    //}
                    if (reservedIds.indexOf(enumId) >= 0) {
                        prosAppNotifWarn("Muuta ID - tämä on jo käytössä")
                        return
                    }
                }
                let enums = addInputValues()
                if (JSON.stringify(enums) !== JSON.stringify(initialEnums)) {
                    newConfig[ATTR_ENUM_VALUES] = enums
                }
                setOptionsCallback(newConfig)
            }}
        />
    }
    return <>
        <div className={"element-set flex-wrap"}>
            <div className={"margin-right"}>
                <TextInput
                    label={"Tunnus"}
                    placeholder={"Kirjoita tunnus"}
                    value={enumId}
                    disabled={isExistingEnumList}
                    onChange={val => {
                        setEnumId(val)
                    }}
                    required={!isEnumTitleValid()}
                    isValid={isEnumTitleValid()}
                    info={"Valinnan tunnusta ei voi muokata myöhemmin"}
                />
                <TextInput
                    label={"Valintalistan kuvaus"}
                    value={description}
                    onChange={val => {
                        setDescription(val)
                    }}
                    multiline={3}
                    disabled={!isEnumTitleValid()}
                />
                {renderEnumList()}
            </div>
            <div>
                <h6>Valintoja voi lisätä kirjauksia muokattaessa</h6>
                <div className={"selection-group selection-group-radio"}>
                    <RadioButton
                        text={"Ei sallittu"}
                        checked={!editorMayAdd && !managerMayAdd}
                        onChange={() => {setMayAdd("none")}}
                    />
                    <RadioButton
                        text={"Laajan käyttöoikeuden käyttäjät"}
                        checked={managerMayAdd}
                        onChange={() => {setMayAdd("mgr")}}
                    />
                    <RadioButton
                        text={"Muokkausoikeuden käyttäjät"}
                        checked={editorMayAdd}
                        onChange={() => {setMayAdd("editor")}}
                    />
                </div>
            </div>
        </div>
        <footer className={"popup-footer margin-top"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={closeCallback}
                />
                {renderConfirmButton()}
            </div>
        </footer>
    </>
}